// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2xffB","fileDisabled":"File_fileDisabled__2IGY2"};